import { FETCH_NAVIGATION_DATA } from '../actions/types';

export default function navigationReducer(state = [], action) {
  switch (action.type) {
      case FETCH_NAVIGATION_DATA:
      return action.data;
    default:
      return state;
  }
}
